module.exports = __webpack_public_path__ + "img/3_Cecum.cbe72fd8.png";